const toCommas = (x) => !x ? 0 : x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");

const toCurrency = (value, maximumFractionDigits = 0, currency = "GBP") =>
    value.toLocaleString(undefined, { style: 'currency', currency, maximumFractionDigits });

export {
    toCommas,
    toCurrency
}